import './App.css';
import './default.css';
import './dashboard.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/home/Home';
import ScrollToTop from './components/ScrollToTop';
import About from './pages/about-us/About';
import PageNotFound from './pages/page-not-found/PageNotFound';
import Personal from './pages/personal/Personal';
import Professional from './pages/professional/Professional';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import Sports from './pages/sports/Sports';
import Vendor from './pages/vendor/Vendor';
import TermsService from './pages/terms-service/TermsService';
import PrivacyPolicy from './pages/privacy-policy/PrivacyPolicy';
import EventForm from './components/EventForm';
import FormLinks from './components/FormLinks';
import SuccessPage from './pages/payment-success/SuccessPage';
import CancelPage from './pages/payment-cancel/CancelPage';
import ThankYou from './pages/thank-you/ThankYou';
function App() {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <>
      <BrowserRouter>
        <Header />
        <ScrollToTop />
        <Routes>
          <Route index element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/form/:label' element={<EventForm />} />
          <Route path='/form-links' element={<FormLinks />} />
          <Route path='/personal' element={<Personal />} />
          <Route path='/Professional' element={<Professional />} />
          <Route path='/sports' element={<Sports />} />
          <Route path='/vendor' element={<Vendor />} />
          <Route path='/terms-service' element={<TermsService />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />

          <Route path="/success" element={<SuccessPage />} />
          <Route path='/thank-you' element={<ThankYou />} />
          <Route path="/cancel" element={<CancelPage />} />

          <Route path="*" element={<PageNotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}


export default App;
